import type { HeroSlide, HeroSlideInput } from '@shop-monorepo/types';
import React from 'react';

import { useUpdateHeroSlide } from '@/hooks/useHeroSlideQueries';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { HeroSlideForm } from './HeroSlideForm';

interface EditHeroSlideFormProps {
  slide: HeroSlide;
}

export const EditHeroSlideForm: React.FC<EditHeroSlideFormProps> = ({ slide }) => {
  const { goToList } = useListReturn(ROUTES.HERO_SLIDES);
  const { mutate: updateHeroSlide, isPending: isSubmitting } = useUpdateHeroSlide();

  const handleSubmit = async (values: HeroSlideInput) => {
    updateHeroSlide(
      { id: slide.id, slide: values },
      {
        onSuccess: () => {
          goToList();
        },
      },
    );
  };

  return (
    <HeroSlideForm initialValues={slide} onSubmit={handleSubmit} isSubmitting={isSubmitting} />
  );
};
